<template>
	<div id="inline-loading-indicator">
		<div class="spinner-box">
			<div class="pulse-container">
				<div class="pulse-bubble pulse-bubble-1" :style="{'background-color': color}"></div>
				<div class="pulse-bubble pulse-bubble-2" :style="{'background-color': color}"></div>
				<div class="pulse-bubble pulse-bubble-3" :style="{'background-color': color}"></div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        color: {
            type: String,
            default: '#20CDDE'
        }
    }
})
</script>

<style lang="stylus" scoped>
@import '../styles/colors.styl';
/* KEYFRAMES */

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: .25;
    transform: scale(.75);
  }
}

.spinner-box {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

/* PULSE BUBBLES */

.pulse-container {
  width: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pulse-bubble {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: primaryColor;
}

.pulse-bubble-1 {
    animation: pulse .4s ease 0s infinite alternate;
}
.pulse-bubble-2 {
    animation: pulse .4s ease .2s infinite alternate;
}
.pulse-bubble-3 {
    animation: pulse .4s ease .4s infinite alternate;
}

</style>